/**
 * Contact form handler for Netlify Forms
 */

import { subscribeToMailchimp } from "./newsletter.js";
import { fullPhoneValue } from "./phone.js";

export function init() {
  const forms = document.querySelectorAll("[data-contact-form]");

  forms.forEach((form) => {
    form.addEventListener("submit", handleSubmit);
  });
}

async function handleSubmit(e) {
  e.preventDefault();

  const form = e.target;
  const button = form.querySelector(".contact-form__submit");
  const messageContainer = form.querySelector("[data-contact-message]");
  const successEl = form.querySelector("[data-contact-success]");
  const errorEl = form.querySelector("[data-contact-error]");
  const fieldsContainer = form.querySelector("[data-contact-fields]");

  // Disable button and show loading state
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = "...";

  // Hide previous messages
  messageContainer.hidden = true;
  successEl.hidden = true;
  errorEl.hidden = true;

  try {
    const formData = new FormData(form);
    formData.append("form-name", form.getAttribute("name"));

    // Submit the dial code and the number as a single field.
    const phone = fullPhoneValue(form);
    if (phone !== null) {
      formData.set("phone", phone);
      formData.delete("phone_country");
    }

    const response = await fetch("", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    });

    if (response.ok) {
      // Hide form fields, show success
      if (fieldsContainer) {
        fieldsContainer.style.display = "none";
      }
      messageContainer.hidden = false;
      successEl.hidden = false;
      errorEl.hidden = true;

      // Track GA4 lead conversion
      const formName = form.getAttribute("name") || "contact";
      if (typeof window.gtag === "function") {
        window.gtag("event", "form_submit", {
          form_id: formName,
          form_name: formName,
          form_destination: location.pathname,
        });
        window.gtag("event", "generate_lead", {
          form_id: formName,
          currency: "EUR",
          value: 1,
        });
      }

      // Subscribe to Mailchimp if newsletter checkbox was checked
      const mailchimpUrl = form.dataset.mailchimpUrl;
      if (formData.get("newsletter") === "yes" && mailchimpUrl) {
        subscribeToMailchimp(formData.get("email"), mailchimpUrl).catch(() => {
          // Silent fail — contact form submission already succeeded
        });
      }
    } else {
      throw new Error("Form submission failed");
    }
  } catch {
    // Show error message
    messageContainer.hidden = false;
    successEl.hidden = true;
    errorEl.hidden = false;
    errorEl.textContent =
      document.documentElement.lang === "en"
        ? "An error occurred. Please try again."
        : "Ein Fehler ist aufgetreten. Bitte versuche es erneut.";
  } finally {
    button.disabled = false;
    button.textContent = originalText;
  }
}
